export default __webpack_public_path__ + "4670756ad0382ffa76a62f78a61fed43.png";